<template>
  <CrudForm
      :title="title"
      :labelSubmit="labelSubmit"
      :storeName="storeName"
      parentStoreName="SuggestedPrices"
      :submit="submit"
      :status="status"
      :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/suggested_prices'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: $route.params.id ? 'Editar' : 'Crear',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider
                  ref="min"
                  rules="required|numberpositivo|without_decimals"
                  v-slot="{ errors }"
              >
              <div class="label-base pb-1">Mínimo</div>
                <v-text-field
                    v-model="data.min"
                    label="Mínimo"
                    type="number"
                    solo
                    hide-details="auto"
                    class="input-base custom-number"
                    prepend-inner-icon="fas fa-coins"
                    :error-messages="errors"
                >
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.min++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.min = Math.max(0, data.min - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col>
              <ValidationProvider
                  ref="max"
                  rules="required|numberpositivo"
                  v-slot="{ errors }"
              >
              <div class="label-base pb-1">Máximo</div>
                <v-text-field
                    v-model="data.max"
                    label="Máximo"
                    type="number"
                    solo
                    hide-details="auto"
                    class="input-base custom-number"
                    prepend-inner-icon="fas fa-coins"
                    :error-messages="errors"
                >
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.max++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.max = Math.max(0, data.max - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {mapState} from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

// Validaciones personalizadas
extend("numberpositivo", {
  validate: (value) => value > 0,
  message: "El campo debe ser mayor a 0.",
});

extend("without_decimals", {
  validate: (value) => value % 1 === 0,
  message: "El valor no debe tener decimales.",
});

export default {
  name: "SuggestedPriceForm",
  mixins: [CrudFormMixin],
  components: {ValidationProvider, ValidationObserver, CrudForm},
  computed: {
    ...mapState({
      status: (state) => state.Faqs.status, // 👀 confirmar que Faqs es el módulo correcto
    }),
  },
  data() {
    return {
      storeName: "Suggested_prices",
      title: "Precio Sugerido",
      data: {
        min: "",
        max: "",
      },
    };
  },
};
</script>
